import { useState, forwardRef } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with a built-in show/hide eye toggle.
 * Renders a relative wrapper containing the Input and an absolutely positioned button.
 * Accepts all standard Input props plus optional `wrapperClassName` and `dataTestId`
 * (the toggle button receives `${dataTestId}-toggle`).
 */
const PasswordInputWithEye = forwardRef(function PasswordInputWithEye(
  { wrapperClassName = "mt-1.5", className = "", dataTestId, ...inputProps },
  ref,
) {
  const [show, setShow] = useState(false);
  return (
    <div className={`relative ${wrapperClassName}`}>
      <Input
        ref={ref}
        type={show ? "text" : "password"}
        className={`border-af focus-visible:ring-terracotta pr-11 ${className}`}
        data-testid={dataTestId}
        {...inputProps}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        data-testid={dataTestId ? `${dataTestId}-toggle` : undefined}
        aria-label={show ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        className="absolute inset-y-0 right-0 w-10 flex items-center justify-center text-af-muted hover:text-terracotta transition-colors"
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});

export default PasswordInputWithEye;
